import { isNil } from 'lodash';
import { LoadingIndicator } from '@shared/components/loading';
import { WorkflowComponentsProvider } from '@shared/scenes/entity/context';
import { useViewTemplateLayout } from '@shared/scenes/workflows/hooks';
import { EntityFormLayout } from './EntityFormLayout';
import { EntityFormProps } from './EntityFormProps';

export function EntityForm(props: EntityFormProps) {
  const { workflowTemplateId, viewTemplateId, layout: layoutOverride } = props;
  const { layout: fetchedLayout, loading } = useViewTemplateLayout(
    workflowTemplateId,
    viewTemplateId,
  );

  // A provided layout (e.g. the builder preview injecting unsaved draft layout) takes precedence
  // over the fetched one and skips the loading gate.
  if ((loading && isNil(layoutOverride)) || isNil(workflowTemplateId)) {
    return <LoadingIndicator fill />;
  }

  return (
    <WorkflowComponentsProvider
      workflowTemplateId={workflowTemplateId}
      viewTemplateId={viewTemplateId}
    >
      <EntityFormLayout {...props} layout={layoutOverride ?? fetchedLayout} />
    </WorkflowComponentsProvider>
  );
}
